export const SPACE_ASSETS_GRID_LIMIT = 50;
export const SPACE_ASSETS_GRID_LIMIT_LOADING = 21;
export const SPACE_ASSETS_THUMBNAIL_HEIGHT = 192;

export enum SPACE_ASSETS_VIEW_TYPE {
  THUMBNAIL = 'thumbnail',
  LIST = 'list',
  GALLERY = 'gallery'
}

export const AM_V2_ASSET_PICKER_VIEW_STORAGE_KEY = 'am-v2-asset-picker-view';

export enum SPACE_ASSETS_VIEW_ICON {
  THUMBNAIL = 'Thumbnail',
  LIST = 'List',
  GALLERY = 'Gallery'
}

export const SPACE_ASSETS_SORT = {
  ASC: 'asc',
  DESC: 'desc'
};

export const SPACE_ASSETS_THUMBNAIL_SORT_KEYS = {
  TITLE: 'title',
  DATE_MODIFIED: 'updated_at',
  DATE_CREATED: 'created_at',
  CRREATED_BY: 'created_by',
  UPDATED_BY: 'updated_by',
  FILE_SIZE: 'file_size',
  NO_SORT: 'no_sort'
};

export const SPACE_ASSETS_THUMBNAIL_SORT_OPTIONS = [
  { label: 'Title', value: SPACE_ASSETS_THUMBNAIL_SORT_KEYS.TITLE, disable: false },
  { label: 'Date Modified', value: SPACE_ASSETS_THUMBNAIL_SORT_KEYS.DATE_MODIFIED, disable: false },
  { label: 'Date Created', value: SPACE_ASSETS_THUMBNAIL_SORT_KEYS.DATE_CREATED, disable: false },
  { label: 'Created By', value: SPACE_ASSETS_THUMBNAIL_SORT_KEYS.CRREATED_BY, disable: false },
  { label: 'Modified By', value: SPACE_ASSETS_THUMBNAIL_SORT_KEYS.UPDATED_BY, disable: false },
  { label: 'File Size', value: SPACE_ASSETS_THUMBNAIL_SORT_KEYS.FILE_SIZE, disable: false },
  { label: 'Ascending', value: SPACE_ASSETS_SORT.ASC, disable: false, isSortOrder: true },
  { label: 'Descending', value: SPACE_ASSETS_SORT.DESC, disable: false, isSortOrder: true },
  { label: 'No Sort', value: SPACE_ASSETS_THUMBNAIL_SORT_KEYS.NO_SORT, disable: true, isSortOrder: true }
];

export const SPACE_ASSETS_SEARCH_OPTIONS = {
  SEARCH: 'search',
  SEARCH_TYPE: 'searchType'
};

export const SPACE_ASSETS_SEARCH_TYPES = {
  SUGGESTIONS: 'suggestions',
  ALL: 'all',
  TITLE: 'title',
  URL: 'URL',
  SHOW_SELECTED: 'Show Only Selected'
};

export const SPACE_ASSETS_SEARCH_CONFIG = {
  searchPlaceholder: 'Search assets by name, type, tag or folder',
  helpText: 'Write something to search'
};

export const ASSET_PRIVACY_KEY = 'asset_access_filter';

// Filter constants for Space Assets Selector Modal
export const DEFAULT_FILTERS = [
  {
    field: 'Space',
    id: 'space_uid',
    operator: '',
    value: '',
    type: 'SPACE'
  },
  {
    field: 'Color',
    id: 'color',
    operator: '',
    value: '',
    type: 'COLOR'
  },
  {
    field: 'Asset Type',
    id: 'asset_type_uid',
    operator: '',
    value: '',
    type: 'ASSET_TYPE'
  },
  {
    field: 'File Size',
    id: 'file_size',
    operator: '',
    value: '',
    type: 'FILE_SIZE'
  },
  {
    field: 'Last Modified By',
    id: 'updated_by',
    operator: '',
    value: '',
    type: 'UPDATED_BY'
  },
  {
    field: 'Last Modified At',
    id: 'updated_at',
    operator: '',
    value: '',
    type: 'UPDATED_AT'
  },
  {
    field: 'Created By',
    id: 'created_by',
    operator: '',
    value: '',
    type: 'CREATED_BY'
  },
  {
    field: 'Created At',
    id: 'created_at',
    operator: '',
    value: '',
    type: 'CREATED_AT'
  },
  {
    field: 'Locales',
    id: 'locale',
    operator: '',
    value: '',
    type: 'LOCALE'
  },
  {
    field: 'Dimensions',
    id: 'dimensions',
    operator: '',
    value: '',
    type: 'DIMENSIONS'
  },
  {
    field: 'Scan Status',
    id: '_asset_scan_status',
    operator: '',
    value: '',
    type: 'SCAN_STATUS'
  },
  {
    field: 'Asset Privacy',
    id: ASSET_PRIVACY_KEY,
    operator: '',
    value: '',
    type: 'PRIVACY'
  }
];

export const FILTER_OPERATORS = {
  EQUALS: '$eq',
  NOT_EQUALS: '$ne',
  IN: '$in',
  NOT_IN: '$nin',
  GREATER_THAN: '$gt',
  LESS_THAN: '$lt',
  GREATER_THAN_OR_EQUAL: '$gte',
  LESS_THAN_OR_EQUAL: '$lte',
  RANGE: '$range',
  REGEX: '$regex',
  CONTAINS: '$contains',
};

export const FILE_SIZE_FORMATS_OPTIONS = [
  { label: 'KB', value: 'kb' },
  { label: 'MB', value: 'mb' },
  { label: 'GB', value: 'gb' }
];

export const FIELDS_LIST_FILTERS_OPTIONS = [
  {
    label: 'Show All Fields',
    value: 'ALL',
    default: true
  },
  {
    label: 'Show Boolean Fields',
    value: 'BOOLEAN',
    default: false
  },
  {
    label: 'Show Text Fields',
    value: 'TEXT',
    default: false
  },
  {
    label: 'Show Number Fields',
    value: 'NUMBER',
    default: false
  },
  {
    label: 'Show All Selected Fields',
    value: 'SELECTED',
    default: false
  },
  {
    label: 'Show All User Fields',
    value: 'USER',
    default: false
  }
];

export const ASSET_SCAN_STATUSES = {
  QUARANTINED: 'quarantined',
  CLEAN: 'clean',
  PENDING: 'pending',
  NOT_SCANNED: 'not_scanned',
};

export const AM_ASSETS_SCAN = 'amAssetsScan';

export const APPLICATION_OCTECT_STREAM = 'application/octet-stream';

export const DISPLAY_LABELS = {
  [ASSET_SCAN_STATUSES.QUARANTINED]: 'Quarantined',
  [ASSET_SCAN_STATUSES.CLEAN]: 'Clean',
  [ASSET_SCAN_STATUSES.PENDING]: 'Pending',
};

export const TOOLTIP_CONTENT = {
  [ASSET_SCAN_STATUSES.QUARANTINED]:
    'Asset scan failed. Malware was detected in this file. Replace or delete this asset with a safe version to continue using it.',
  [ASSET_SCAN_STATUSES.CLEAN]: 'Asset scan successful. This asset is safe and ready to use.',
  [ASSET_SCAN_STATUSES.PENDING]:
    'Asset scan is in progress. This asset cannot be downloaded or used until the scan is complete.',
};

const ColorBaseRedStatusQuarantined = '#FFEEEB';
const ColorBaseYellowStatusPending = '#FFEEEB';
const ColorBaseGreenStatusClean = '#f5fffc';

export const PILL_BACKGROUND: Record<string, string> = {
  [ASSET_SCAN_STATUSES.QUARANTINED]: ColorBaseRedStatusQuarantined,
  [ASSET_SCAN_STATUSES.CLEAN]: ColorBaseGreenStatusClean,
  [ASSET_SCAN_STATUSES.PENDING]: ColorBaseYellowStatusPending,
};

export const ASSET_SCAN_STATUS_ROUTE = '_asset_scan_status';

export const SCAN_STATUS_FILTER_OPTIONS = [
  { id: ASSET_SCAN_STATUSES.CLEAN, name: DISPLAY_LABELS[ASSET_SCAN_STATUSES.CLEAN] },
  { id: ASSET_SCAN_STATUSES.QUARANTINED, name: DISPLAY_LABELS[ASSET_SCAN_STATUSES.QUARANTINED] },
  { id: ASSET_SCAN_STATUSES.PENDING, name: DISPLAY_LABELS[ASSET_SCAN_STATUSES.PENDING] },
];

export const PRIVACY_FILTER_VALUES = {
  ALL: 'none',
  PUBLIC: 'public',
  RESTRICTED: 'private',
};

export const PRIVACY_FILTER_OPTIONS = [
  { id: PRIVACY_FILTER_VALUES.ALL, name: 'All' },
  { id: PRIVACY_FILTER_VALUES.RESTRICTED, name: 'Restricted' },
  { id: PRIVACY_FILTER_VALUES.PUBLIC, name: 'Public' },
];